document.addEventListener("DOMContentLoaded", () => {
  const tooltip = document.getElementById('tooltip');
  let currentOpenHotspot = null;
  let initialScrollPosition = null;
  // Helper function: Calculate Tooltip Position
  function calculateTooltipPosition(hotspot) {
    const rect = hotspot.getBoundingClientRect();
    const tooltipWidth = tooltip.offsetWidth;
    const tooltipHeight = tooltip.offsetHeight;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    let top, left;
    if (rect.left + tooltipWidth > viewportWidth) {
      left = viewportWidth - tooltipWidth - 10;
    } else if (rect.left < 10) {
      left = 10;
    } else {
      left = rect.left + window.scrollX;
    }
    if (rect.bottom + tooltipHeight + 35 > viewportHeight) {
      top = rect.top + window.scrollY - tooltipHeight - 10;
    } else {
      top = rect.top + window.scrollY + 35;
    }
    return { top, left };
  }
  // Helper function: Show Tooltip
  function showTooltip(hotspot) {
    const content = hotspot.querySelector('.hotspot-content');
    if (!content) return;
    const title = content.querySelector('h4')?.innerHTML || '';
    const description = content.querySelector('p')?.innerHTML || '';
    const { top, left } = calculateTooltipPosition(hotspot);
    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
    document.getElementById('tooltip-title').innerHTML = title;
    document.getElementById('tooltip-description').innerHTML = description;
    tooltip.classList.remove('noshow');
    tooltip.classList.add('show');
    const icon = hotspot.querySelector('span');
    if (icon) icon.classList.add('rotated');
    // Add active class to stop pulse animation
    hotspot.classList.add('active');
    currentOpenHotspot = hotspot;
    // Record the scroll position when the tooltip is opened
    initialScrollPosition = window.scrollY;
  }
  // Helper function: Close Tooltip
  function closeTooltip() {
    if (!currentOpenHotspot) return;
    tooltip.classList.remove('show');
    tooltip.classList.add('noshow');
    const icon = currentOpenHotspot.querySelector('span');
    if (icon) icon.classList.remove('rotated');
    // Remove active class to re-enable pulse animation
    currentOpenHotspot.classList.remove('active');
    currentOpenHotspot = null;
    initialScrollPosition = null; // Reset scroll position
  }
  // Click Event: Hotspots
  document.querySelectorAll('.hotspot').forEach((hotspot) => {
    hotspot.addEventListener('click', function (event) {
      if (currentOpenHotspot === this) {
        closeTooltip();
      } else {
        closeTooltip();
        showTooltip(this);
      }
      event.stopPropagation();
    });
  });
  // Click Event: Close Button
  document.getElementById('close-tooltip').addEventListener('click', closeTooltip);
  // Close Tooltip on outside click
  document.addEventListener('click', (event) => {
    if (!tooltip.contains(event.target)) {
      closeTooltip();
    }
  });
  // Close Tooltip on scroll beyond 250px
  window.addEventListener('scroll', () => {
    if (initialScrollPosition !== null && Math.abs(window.scrollY - initialScrollPosition) > 250) {
      closeTooltip();
    }
  });
});